import React, {useEffect, useRef, useContext, useState} from 'react';
import {isEmpty} from "@helpers/helpers";
import {PropertiesContext, PropertiesDispatcherContext} from "@providers/properties";
import CircleLoading from "@molecules/lotties/circle_loading";
import ButtonBase from "../../atoms/button.base";

/**
 * @return {string}
 */
var allowRequest = 1;

export default function LoadMore({loadMoreRef, handleGetProperties, className}) {
    const properties_context = useContext(PropertiesContext);
    const properties_dispatcher = useContext(PropertiesDispatcherContext);

    const loadMore = properties_context.load_more;
    const loadMoreDefaultRef = useRef('');

    const handleLoadMore = async (get_more = false) => {
        allowRequest = 2;

        if (loadMore.has_more && ((!loadMore.loading) || get_more)) {
            const page = loadMore.page;

            if ((page % 2 === 0) || get_more) {

                await properties_dispatcher({
                    type: 'LOAD_MORE',
                    payload: {
                        page: page,
                        loading: true,
                        has_more: loadMore.has_more,
                        default_loading: false,
                    }
                });

                handleGetProperties('ADD_PREV', false, false, false, loadMore).then(result => {
                    if (result) {
                        allowRequest = 1;
                    }
                });
            }
        }
    };

    useEffect(() => {
        const handleScroll = (event) => {
            const ref = !isEmpty(loadMoreRef) ? loadMoreRef : loadMoreDefaultRef;

            if (!isEmpty(ref) && !isEmpty(ref.current)) {
                const loadMoreBtn = ref.current.offsetTop;

                const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
                const windowBottom = windowHeight + window.pageYOffset;

                if ((windowBottom > loadMoreBtn - 500) && allowRequest === 1 && !isEmpty(loadMore)) {
                    allowRequest = 2;
                    handleLoadMore();
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    });

    if ((loadMore && loadMore.has_more)) {
        return (
            <div ref={loadMoreDefaultRef} className={"text-center " + (className ? className : '')}>
                {
                    (((loadMore.page) % 2 === 0) || loadMore.loading) ?
                        <div className="d-flex align-items-center justify-content-center">
                            <div><CircleLoading width={32} height={32}/></div>
                            <p className="h3 mr-8">در حال دریافت...</p>
                        </div>
                        :
                        <ButtonBase onClick={() => handleLoadMore(true)}>نمایش آگهی‌های بیشتر</ButtonBase>
                }
            </div>
        )
    }

    return <></>
}